export const ESC_KEY = 27;
export const ENTER_KEY = 13;
export const TAB_KEY = 9;
